import React from 'react'
import styled from 'styled-components'

import Logo from './Logo'
import SearchField from './SearchField'
import MoreMenu from './MoreMenu'
import MenuItem from './MenuItem'

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
`

const SearchFieldWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`

const Menu = styled.div`
  display: flex;
`

const SmallHeader = ({ menu, moreMenu, searchField }) => (
  <Content>
    <Logo />
    {searchField && (
      <SearchFieldWrapper>
        <SearchField />
      </SearchFieldWrapper>
    )}
    <Menu>
      {menu.map((menuItem, i) => <MenuItem key={i} {...menuItem} />)}
      {moreMenu && moreMenu.length > 0 && <MoreMenu items={moreMenu} />}
    </Menu>
  </Content>
)

export default SmallHeader



// WEBPACK FOOTER //
// ./src/components/Header/LargeHeader.js